"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isScalar = void 0;
var _1 = require(".");
var util_1 = require("./helpers/util");
var isScalar = function (schema, params) {
    if (params === void 0) { params = { root: true }; }
    var def = schema._def;
    var returnValue = false;
    switch (def.t) {
        case _1.ZodTypes.string:
            returnValue = true;
            break;
        case _1.ZodTypes.number:
            returnValue = true;
            break;
        case _1.ZodTypes.bigint:
            returnValue = true;
            break;
        case _1.ZodTypes.boolean:
            returnValue = true;
            break;
        case _1.ZodTypes.undefined:
            returnValue = true;
            break;
        case _1.ZodTypes.null:
            returnValue = true;
            break;
        case _1.ZodTypes.any:
            returnValue = false;
            break;
        case _1.ZodTypes.unknown:
            returnValue = false;
            break;
        case _1.ZodTypes.never:
            returnValue = false;
            break;
        case _1.ZodTypes.void:
            returnValue = false;
            break;
        case _1.ZodTypes.array:
            if (params.root === false)
                return false;
            returnValue = exports.isScalar(def.type, { root: false });
            break;
        case _1.ZodTypes.object:
            returnValue = false;
            break;
        case _1.ZodTypes.union:
            returnValue = def.options.every(function (x) { return exports.isScalar(x); });
            break;
        case _1.ZodTypes.intersection:
            returnValue = exports.isScalar(def.left) && exports.isScalar(def.right);
            break;
        case _1.ZodTypes.tuple:
            returnValue = def.items.every(function (x) { return exports.isScalar(x, { root: false }); });
            break;
        case _1.ZodTypes.lazy:
            returnValue = exports.isScalar(def.getter());
            break;
        case _1.ZodTypes.literal:
            returnValue = true;
            break;
        case _1.ZodTypes.enum:
            returnValue = true;
            break;
        case _1.ZodTypes.nativeEnum:
            returnValue = true;
            break;
        case _1.ZodTypes.function:
            returnValue = false;
            break;
        case _1.ZodTypes.record:
            returnValue = false;
            break;
        case _1.ZodTypes.map:
            returnValue = false;
            break;
        case _1.ZodTypes.date:
            returnValue = true;
            break;
        case _1.ZodTypes.promise:
            returnValue = false;
            break;
        case _1.ZodTypes.transformer:
            returnValue = exports.isScalar(def.output);
            break;
        case _1.ZodTypes.optional:
            returnValue = exports.isScalar(def.innerType);
            break;
        case _1.ZodTypes.nullable:
            returnValue = exports.isScalar(def.innerType);
            break;
        default:
            util_1.util.assertNever(def);
    }
    return returnValue;
};
exports.isScalar = isScalar;
//# sourceMappingURL=isScalar.js.map